import { MenuConfigInterface } from "../Interface/menu-config-interface";
import { ActiveClass } from "./active-class";
import { AppUrl } from "./app-url";
import { ModuleConfig } from "./module-config";

export const PrivateMenuMaster: Array<MenuConfigInterface> = [
  {
    activeClass: ActiveClass.DASHBOARD,
    name: "Dashboard",
    iconUrl: "assets/images/dashboardIcon.svg",
    iconWhiteUrl: "assets/images/dashboardIcon-white.svg",
    iconClassName: "dashboard",
    url: "/" + AppUrl.DASHBOARD,
    moduleId: [],
  },
   {
    activeClass: ActiveClass.HEARTBEAT,
    name: "Heartbeat",
    iconUrl: "assets/images/device.svg",
    iconWhiteUrl: "assets/images/device-white.svg",
    iconClassName: "monitor_heart",
    url: "/" + AppUrl.HEARTBEAT + "/" + AppUrl.LIST_OPERATION,
    moduleId: [],
  },
   {
    activeClass: ActiveClass.ERROR_ALARM,   // Add this to your ActiveClass enum
    name: "Error Alarm",
    iconUrl: "assets/images/error-alarm.svg",       // Use proper icon for error alarm
    iconWhiteUrl: "assets/images/error-alarm-white.svg",
    iconClassName: "error_outline",
    url: "/" + AppUrl.ERROR_ALARM + "/" + AppUrl.LIST_OPERATION,
    moduleId: [],  // Add this to your ModuleConfig
  },
  {
  activeClass: ActiveClass.TRANSACTION,
  name: "Transaction",
  iconUrl: "assets/images/device.svg",
  iconWhiteUrl: "assets/images/device-white.svg",
  iconClassName: "receipt_long",
  url: "/" + AppUrl.TRANSACTION + "/" + AppUrl.LIST_OPERATION,
  moduleId: [],
},
{
  activeClass: ActiveClass.SYSTEM_SPECIFICATION,
  name: "System Specification",
  iconUrl: "assets/images/configuration.svg",
  iconWhiteUrl: "assets/images/configuration-white.svg",
  iconClassName: "settings",
  url:
    "/" +
    AppUrl.SYSTEM_SPECIFICATION +
    "/" +
    AppUrl.LIST_OPERATION,
  moduleId: [], // or [ModuleConfig.SYSTEM_SPECIFICATION.id]
},
{
  activeClass: ActiveClass.MACHINE,
  name: "Machine",
  iconUrl: "assets/images/device.svg",
  iconWhiteUrl: "assets/images/device-white.svg",
  iconClassName: "devices",
  url: "/" + AppUrl.MACHINE + "/" + AppUrl.LIST_OPERATION,
  moduleId: [],
}
];
